import React from "react";
import {
  Box,
  Text,
  Center,
  Link
} from '@chakra-ui/react'

import styled from '@emotion/styled';

const Icon = styled(Box)`
display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
    cursor: pointer;
    > p {
        color: #70A37F;
    }
    > div > svg {
        fill: #70A37F;
    }

    &:hover {
        > p {
            color: #40634A;
        }
        > div > svg {
            fill: #40634A;
        }
    }
`

const FacebookGeo = (props) => {
  return (
    <Icon as={Link} href="https://www.facebook.com/TetonGeotourismCenter" target="_blank" rel="noopener noreferrer" _hover={{textDecoration: 'none'}}>
      <Center  w="35%" mx="auto">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 44.771 44.771">
    <path id="facebook-square-brands" d="M39.974,32H4.8A4.8,4.8,0,0,0,0,36.8V71.974a4.8,4.8,0,0,0,4.8,4.8H18.513V61.55h-6.3V54.385h6.3v-5.46c0-6.211,3.7-9.642,9.361-9.642a38.141,38.141,0,0,1,5.548.484v6.1H30.3c-3.079,0-4.039,1.911-4.039,3.87v4.652h6.873l-1.1,7.164H26.258V76.771H39.974a4.8,4.8,0,0,0,4.8-4.8V36.8A4.8,4.8,0,0,0,39.974,32Z" transform="translate(0 -32)"/>
   </svg>
   </Center>
   <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}}>
        Geo
    </Text>
   </Icon>
  );
};

export default FacebookGeo;